var _path, _circle, _circle2, _circle3, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInvitesEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 40C52 26 64 16 80 16C96 16 108 26 108 40C108 54 96 64 80 64C76.5 64 73.3 63.5 70.3 62.5L55 70L59 56C54 52 52 46.5 52 40Z",
    fill: "#DBEAFE",
    stroke: "#9CA3AF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 40,
    r: 3.5,
    fill: "#9CA3AF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 3.5,
    fill: "#9CA3AF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 40,
    r: 3.5,
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 100L66 68L50 110L39 93Z",
    fill: "white",
    stroke: "#9CA3AF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93L66 68",
    stroke: "#9CA3AF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 14L36 8M38 28L28 25M36 42L27 45",
    stroke: "#9CA3AF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvitesEmpty);
export default __webpack_public_path__ + "static/media/noInvitesEmpty.3a812a34cab2756e2f67e2c30c627961.svg";
export { ForwardRef as ReactComponent };